

import React from "react";

const sectionStyle: React.CSSProperties = {
  background: "white",
  borderRadius: 18,
  padding: "20px 22px",
  border: "1px solid #d8e1eb",
  boxShadow: "0 8px 24px rgba(23,59,87,0.06)",
  lineHeight: 1.8,
};

const Privacy: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #eef4fb 0%, #f8fbff 100%)",
        padding: "32px 16px 48px",
        boxSizing: "border-box",
      }}
    >
      <div style={{ maxWidth: 960, margin: "0 auto" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #0c2031 0%, #173b57 54%, #2a6b98 100%)",
            color: "white",
            borderRadius: 24,
            padding: "28px 24px",
            boxShadow: "0 18px 40px rgba(12,32,49,0.18)",
            marginBottom: 20,
          }}
        >
          <div style={{ fontSize: 13, opacity: 0.85, letterSpacing: "0.08em", marginBottom: 8 }}>
            dachouの謎解き問題集
          </div>
          <h1 style={{ margin: 0, fontSize: 32, lineHeight: 1.2 }}>プライバシーポリシー</h1>
          <div style={{ marginTop: 10, fontSize: 14, opacity: 0.85, lineHeight: 1.7 }}>
            当サイトにおける個人情報の取り扱い、広告配信、Cookieの利用などについてご説明します。
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>1. 広告について</h2>
            <p>
              当サイトでは、現在広告配信サービスを利用していません。
            </p>
            <p>
              今後、Google AdSenseなどの第三者配信広告サービスを導入する場合があります。
              その際は、本プライバシーポリシーを更新した上で、Cookie等の利用についてご案内いたします。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>2. アクセス解析について</h2>
            <p>
              当サイトでは、サービス向上のためにアクセス解析を利用する場合があります。
              これにより収集される情報は匿名であり、個人を特定するものではありません。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>3. 個人情報の利用目的</h2>
            <p>
              当サイトでは、お問い合わせなどの際に、名前やメールアドレス等の個人情報を入力いただく場合があります。
              これらの個人情報は、質問への回答や必要な情報を電子メールなどでご連絡する場合に利用するものであり、それ以外の目的では利用しません。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>4. 個人情報の第三者への開示</h2>
            <p>
              取得した個人情報は適切に管理し、以下の場合を除いて第三者に開示することはありません。
            </p>
            <ul style={{ marginBottom: 0 }}>
              <li>本人の同意がある場合</li>
              <li>法令に基づき開示が必要な場合</li>
            </ul>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>5. 免責事項</h2>
            <p>
              当サイトに掲載されている情報については、可能な限り正確な情報を提供するよう努めていますが、その正確性や安全性を保証するものではありません。
              当サイトの利用によって生じた損害等については、一切の責任を負いかねます。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>6. 著作権について</h2>
            <p>
              当サイトに掲載されているコンテンツ（文章・画像など）の著作権は、運営者に帰属します。
              無断転載を禁止します。
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={{ marginTop: 0, color: "#173b57" }}>7. プライバシーポリシーの変更</h2>
            <p>
              本ポリシーの内容は、法令等の変更に応じて予告なく変更される場合があります。
            </p>
          </section>
        </div>

        <div
          style={{
            marginTop: 18,
            textAlign: "right",
            color: "#667085",
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          最終更新日：2026年5月21日
        </div>
      </div>
    </div>
  );
};

export default Privacy;